import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Container } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getLocalStorageItem, setLocalStorageItem } from "../../_helpers";
import SelectResponsiblePerson from "../Survey/components/SelectResponsiblePerson";
import { useDispatch } from "react-redux";
import { surveyActions } from "../../_actions";
import { useHistory } from "react-router-dom";
import { flushSync } from "react-dom";
import { apps, LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import DataGridV2 from "../../components/DataGridV2";
import { INITIAL_ROW_SELECTION_MODEL } from "../../components/DataGridV2/constants";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { getWbEmailLinkListColumns } from "./wbEmailLinkListUtils";

export function EmailLinkLists(props) {
  const classes = useStyles();
  const apiRef = useGridApiRef();
  const { applicationManagerItems, getApplicationLoading } = useSelector(
    (state) => state.surveying
  );
  const app = useSelector((state) => state.app);
  const { wbEmailLinkingInfo = [] } = applicationManagerItems || {};
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedEmailId, setSelectedEmailId] = useState(null);
  const [oldEmailId, setOldEmailId] = useState(null);
  const [organizationLoading, setOrganizationLoading] = useState(false);
  const { t , i18n} = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const keyPrefix = app === apps.settingModule ? "SETTING" : "GENERAL";
  const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
    const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
        LOCAL_STORAGE_GRID_KEYS.WB_EMAIL_LINK_LIST_PAGINATION[keyPrefix], undefined
    ))
  const rows = wbEmailLinkingInfo?.map((row, index) => ({
    id: row.loginId || index,
    ...row,
  }));

  const handleLinkEmail = ({ loginId, ...data }) => {
    dispatch(
      surveyActions.linkEmail(selectedEmailId, loginId, oldEmailId, data)
    );
    setSelectedEmailId(null);
    setOldEmailId(null);
  };

  useEffect(() => {
    dispatch(surveyActions.getApplicationManagerActionItem());
  }, [history.location.key]);
 
  const columns = getWbEmailLinkListColumns({t,keyPrefix,i18n,apiRef,setOldEmailId,setSelectedEmailId,setAnchorEl})
 const onPaginationModelChange = useCallback((newPaginationModel) => {
        setPaginationModel(newPaginationModel)
        setLocalStorageItem(
          LOCAL_STORAGE_GRID_KEYS.WB_EMAIL_LINK_LIST_PAGINATION[keyPrefix],
          newPaginationModel
        );
      }, [keyPrefix])

        const getWbEmailLinkListForPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
          const userSelectedRows = isAllSelected ? wbEmailLinkingInfo : idsToExport.map(id => wbEmailLinkingInfo?.find(item => item?.wbProjectId === id));
          return userSelectedRows;
        };
  return (
    <Container maxWidth={false} className={classes.mainContainer}>
      <Box display="flex" flexDirection="column" sx={{ height: "100%" }}>
      <Box p={2} >
        <Typography className={classes.headerTitle} variant='h6'>{t("settings.emailList.title")}</Typography>
      </Box>
      <Box sx={{flex:1,minHeight:0}}>
      <DataGridV2
        localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_EMAIL_LINK_LIST_SEARCH_TEXT[keyPrefix]}
        localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_EMAIL_LINK_LIST_COLUMN_FILTER[keyPrefix]}
        localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_EMAIL_LINK_LIST_COLUMN_SORT[keyPrefix]}
        localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_EMAIL_LINK_LIST_COLUMN_ORDER[keyPrefix]}
        localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_EMAIL_LINK_LIST_COLUMN_WIDTH[keyPrefix]}
        localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_EMAIL_LINK_LIST_COLUMN_VISIBILITY[keyPrefix]}
        apiRef={apiRef}
        checkboxSelection
        rows={rows}
        loading={getApplicationLoading}
        columns={columns}
        pagination
        filterMode="client"
        {...(!!paginationModel && { paginationModel })}
        onPaginationModelChange={onPaginationModelChange}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
        }}
        toolbarProps={{
          selectedRows: rowSelectionModel,
          getData: getWbEmailLinkListForPrintAndDownload,
          title:t("settings.emailList.title")
        }}
      />
      </Box>
      </Box>
      <SelectResponsiblePerson
        anchorEl={anchorEl}
        customTitle={"Login Person"}
        customButtonTitle={"Link"}
        customOplosser
        hideExtraInfo
        onSubmit={(data) => handleLinkEmail(data)}
        loading={organizationLoading}
        setLoading={(val) => 
          flushSync(()=>{
            setOrganizationLoading(val);
          })
        }
        onClose={(data) => {
          setAnchorEl(null);
          setSelectedEmailId(null);
        }}
      />
    </Container>
  );
}

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    width: "100%",
    height:'100%',
    overflow: "auto",
    padding: theme.spacing(0),
    background: theme.palette.common.white,
  },
}));
